import { EnumTypeValue } from "@/shared/types";

export const BETROKKEN_STATIONS_QUERY_KEY = "betrokken-stations";

export const BetrokkenStationsBetrokkenheid = {
    /**
     * @deprecated use {@link DEEL_VAN_DOSSIER_REIKWIJDTE} instead
     */
    DEEL_VAN_DOSSIER_TRAJECT: "DeelVanDossierTraject",
    DEEL_VAN_DOSSIER_REIKWIJDTE: "DeelVanDossierReikwijdte",
    VESTIGING: "Vestiging",
    VSM_BINNEN_TRAJECT: "VsmBinnenVersperring",
    VSM_BUITEN_TRAJECT: "VsmBuitenVersperring",
    VSM_DEEL_VAN_OMLEIDING: "VsmDeelVanOmleiding",
    VSM_KERING: "VsmKering",
    OMREIS_ROUTE: "OmreisRoute",
    TVV: "Tvv",
    EVACUATIE_AFZET_STATION: "EvacuatieAfzetStation",
    /**
     * @deprecated use {@link MEDEWERKERS_OP_STATION} instead
     */
    VRIJWILLIGERS: "Vrijwilligers",
    MEDEWERKERS_OP_STATION: "MedewerkersOpStation",
    HANDMATIG: "Handmatig",
} as const;

type BetrokkenStationsBetrokkenheidFilterTypes = "faciliteiten";

export const betrokkenStationsBetrokkenheidFilters: Record<BetrokkenStationsBetrokkenheidFilterTypes, BetrokkenStationsBetrokkenheid[]> = {
    faciliteiten: [
        BetrokkenStationsBetrokkenheid.DEEL_VAN_DOSSIER_TRAJECT,
        BetrokkenStationsBetrokkenheid.DEEL_VAN_DOSSIER_REIKWIJDTE,
        BetrokkenStationsBetrokkenheid.VSM_BINNEN_TRAJECT,
        BetrokkenStationsBetrokkenheid.VSM_KERING,
        BetrokkenStationsBetrokkenheid.VESTIGING,
        BetrokkenStationsBetrokkenheid.HANDMATIG,
    ],
};

export type BetrokkenStationsBetrokkenheid = EnumTypeValue<typeof BetrokkenStationsBetrokkenheid>;
